import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";
// Assets
import CloseIcon from "../../../assets/svg/CloseIcon";
import LogoImg from "../../../assets/images/s001.png";

export default function Sidebar({ sidebarOpen, toggleSidebar, sessionToken, sessionUser }) {
  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <img className="radius8" src={LogoImg} alt="GlupTickets Logo" style={{zIndex: 9, width:'170px', height:'40px'}} />
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <LinkScroll
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Inicio
          </LinkScroll>
        </li>
        {/* <li className="semiBold font15 pointer">
          <LinkScroll
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="services"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Services
          </LinkScroll>
        </li>
         <li className="semiBold font15 pointer">
          <LinkScroll
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="projects"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Projects
          </LinkScroll>
        </li>
        <li className="semiBold font15 pointer">
          <LinkScroll
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="blog"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Blog
          </LinkScroll>
        </li> */}
        <li className="semiBold font15 pointer">
          <LinkScroll
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="pricing"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Precios
          </LinkScroll>
        </li>
        <li className="semiBold font15 pointer">
          <LinkScroll
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="contact"
            spy={true}
            smooth={true}
            offset={-60}
          >
            Guia
          </LinkScroll>
        </li>
      </UlStyle>
      <UlStyle className="flexSpaceCenter">
        <li className="semiBold font15 pointer">
        {Boolean(!sessionToken) 
              ? <Link to={"/app"} style={{ padding: "10px 30px 10px 0" }} className="whiteColor">
                Iniciar sesión
              </Link>
              : <Link to={"/app/logout"} style={{ padding: "10px 30px 10px 0" }} className="whiteColor">
                Cerrar sesión
              </Link>
        }
        </li>
        <li className="semiBold font15 pointer flexCenter">
          <Link to={"/app/panel"}  className="radius8 lightBg" style={{ padding: "10px 15px" }}>
            {Boolean(!sessionToken) ? "Empezar" : "Mi Panel" }
          </Link>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
